import { Sun, Moon } from "lucide-react";
import { useSite } from "@/lib/site";

export const LangToggle = ({ id = "header" }) => {
  const { lang, setLang } = useSite();
  return (
    <div className="flex rounded-full border border-[var(--line)] p-0.5 font-mono text-xs" data-testid={`${id}-lang-toggle`}>
      {["es", "en"].map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          data-testid={`${id}-lang-${l}`}
          className={`rounded-full px-2.5 py-1 uppercase transition-colors ${lang === l ? "bg-[#8B5CF6] text-white" : "text-[var(--muted)] hover:text-[var(--text)]"}`}
        >
          {l}
        </button>
      ))}
    </div>
  );
};

export const ThemeToggle = ({ id = "header" }) => {
  const { theme, setTheme } = useSite();
  const dark = theme === "dark";
  return (
    <button
      onClick={() => setTheme(dark ? "light" : "dark")}
      data-testid={`${id}-theme-toggle`}
      aria-label="Toggle theme"
      className="grid h-9 w-9 place-items-center rounded-full border border-[var(--line)] text-[var(--muted)] transition-colors hover:border-[#8B5CF6] hover:text-[var(--text)]"
    >
      {dark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
};
